import LoadingSpinner from '../components/LoadingSpinner.js'
import HeroStoryList from '../components/HeroStoryList.js';
export default class StoriesPage{
    constructor(app, params){
        this.app = app;
        this.params = params;
    }

    async mount(container) {
        this.container = container;
        this.render();
    }

    render(){
        this.container. innerHTML = `
            <div id="story-page">
                <div id="loading"></div>
                <div id="story-list"></div>
            </div>
        `;
        this.renderStoryList();
    }

    async renderStoryList(){

        // this.app.telegram.tg.BackButton.show();
        // this.app.pathStory.push('/stories');

        const clickHandler = (id)=> {
            this.app.api.storyID = id;
            this.app.api.startDialog();
            this.app.telegram.close();
        }
        
        const storyList = this.container.querySelector('#story-list');
        const storiesJSON = await this.app.api.getHeroStories();
        const storyListComponent = new HeroStoryList({
            stories: storiesJSON,
            clickHandler: clickHandler
        });
        storyListComponent.render(storyList);
    }
}